import { useState, useEffect } from 'react';

interface HeaderProps {
  /** 右上角登录用户昵称（首页由 index 接口返回，其他页面默认显示老板） */
  nickname?: string;
}

export default function Header({ nickname = '老板' }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [unreadCount] = useState(3);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 transition-all duration-300 ${
        scrolled
          ? 'bg-primary-500 shadow-lg shadow-primary-500/20'
          : 'bg-primary-500'
      }`}
    >
      <div className="flex items-center justify-between px-4 h-12">
        {/* Logo */}
        <div className="flex items-center gap-1.5">
          <div className="w-7 h-7 bg-white/20 rounded-lg flex items-center justify-center">
            <span className="text-white text-xs font-bold">ZTC</span>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-white text-base font-bold tracking-wide">
          众泰成商城
        </h1>

        {/* Right actions */}
        <div className="flex items-center gap-3">
          <span className="text-white/90 text-xs">{nickname}</span>
        </div>
      </div>
    </header>
  );
}